module.exports = __webpack_public_path__ + "img/Engineering_BG.2be39c2e.svg";